import { render, staticRenderFns } from "./PlanManage.vue?vue&type=template&id=20eff761&"
import script from "./PlanManage.vue?vue&type=script&lang=js&"
export * from "./PlanManage.vue?vue&type=script&lang=js&"
import style0 from "./PlanManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports